var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('review-report-view',{attrs:{"caseId":_vm.caseId,"routeFindingsName":'ReviewReportFindingsView',"routeCommentsName":'ReviewReportCommentsView'}})}
var staticRenderFns = []

export { render, staticRenderFns }